import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 mt-auto">
      <div className="container mx-auto px-4 py-8">
        {/* Section principale */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-6">
          {/* Colonne 1 - À propos */}
          <div>
            <h3 className="font-bold text-lg mb-3 text-gray-900 dark:text-white">
              Remadia Health
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
              Votre compagnon santé au quotidien, pour tous les âges.
            </p>
            <div className="mt-4 text-xs text-gray-500 dark:text-gray-500">
              <p>🇫🇷 Service français</p>
              <p>🔒 Données chiffrées AES-256-GCM</p>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
              <p className="text-xs text-gray-500 dark:text-gray-500 mb-1">Une création de</p>
              <a
                href="https://vandomia.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-semibold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
              >
                Vandomia →
              </a>
            </div>
          </div>

          {/* Colonne 2 - Navigation */}
          <div>
            <h4 className="font-semibold mb-3 text-gray-900 dark:text-white">Navigation</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/articles"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  Articles
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  À propos
                </Link>
              </li>
              <li>
                <Link
                  to="/tarifs"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  Tarifs
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 3 - Informations légales */}
          <div>
            <h4 className="font-semibold mb-3 text-gray-900 dark:text-white">
              Informations légales
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/legal/cgu"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  CGU
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/privacy"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/mentions"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/disclaimer"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  Avertissement médical
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/cookies"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  Cookies
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  Assistance
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 4 - Contact & Urgences */}
          <div>
            <h4 className="font-semibold mb-3 text-gray-900 dark:text-white">
              Contact & Urgences
            </h4>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <li>
                <a
                  href="mailto:contact@remadia.com"
                  className="hover:text-blue-600 dark:hover:text-blue-400 transition"
                >
                  contact@remadia.com
                </a>
              </li>
            </ul>

            <div className="mt-4 p-3 bg-red-50 dark:bg-red-900/20 rounded border border-red-200 dark:border-red-800">
              <p className="text-xs font-semibold text-red-800 dark:text-red-300 mb-1">
                🚨 Urgence médicale
              </p>
              <p className="text-xs text-red-700 dark:text-red-400">
                SAMU : <span className="font-bold">15</span> | Pompiers :{' '}
                <span className="font-bold">18</span>
              </p>
            </div>
          </div>
        </div>

        {/* Barre de séparation */}
        <div className="border-t border-gray-300 dark:border-gray-700 pt-6">
          {/* Disclaimer rapide */}
          <div className="mb-4 text-center">
            <p className="text-xs text-gray-500 dark:text-gray-500 max-w-3xl mx-auto">
              ⚠️ <strong>Avertissement :</strong> Remadia Health est un outil d'information. Il ne
              remplace pas une consultation médicale. En cas d'urgence, appelez le 15.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center text-sm text-gray-500 dark:text-gray-400">
            <p>© {currentYear} Remadia Health. Tous droits réservés.</p>
            <p className="text-xs mt-1">
              Made in France 🇫🇷 · Une marque{' '}
              <a
                href="https://vandomia.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
              >
                Vandomia
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;